module.exports = __webpack_public_path__ + "static/img/putiItemNew3.aba9735.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/putiItemNew3.jpg
// module id = KF7x
// module chunks = 0